import { render, staticRenderFns } from "./ReactMountHome.vue?vue&type=template&id=d428c1c4"
import script from "./ReactMountHome.vue?vue&type=script&lang=ts"
export * from "./ReactMountHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d428c1c4')) {
      api.createRecord('d428c1c4', component.options)
    } else {
      api.reload('d428c1c4', component.options)
    }
    module.hot.accept("./ReactMountHome.vue?vue&type=template&id=d428c1c4", function () {
      api.rerender('d428c1c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/ReactMountHome.vue"
export default component.exports